import React from "react";
import BondRetrievalBillingInformation from "./BondRetrievalBillingInformation";
import { GoogleAutoComplete, LabeledCreatableSelect } from "./TrusteeBondRetrieveShared";

const TrusteeBillingInformationForm = (props) => (
  <BondRetrievalBillingInformation
    bondType="trustee"
    GoogleAutoComplete={GoogleAutoComplete}
    LabeledCreatableSelect={LabeledCreatableSelect}
    {...props}
  />
);

export default TrusteeBillingInformationForm;
